// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
  Box,
  Link,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import { useHistory } from 'react-router-dom';
import { IMPORT } from '../../../routes';
import { PERSISTENT_PREREQUISITES } from '../constants';

const CfDownloadStep = () => {
  const history = useHistory();

  return (
    <SpaceBetween size="m">
      <Box>
        <TextContent>
          <h3>Prerequisites</h3>
          <ul>
            {PERSISTENT_PREREQUISITES.map((prereq) => (
              <li key={prereq}>{prereq}</li>
            ))}
          </ul>
        </TextContent>
      </Box>
      <Box>
        <TextContent>
          <p>
            Navigate to the{' '}
            <Link
              href={IMPORT}
              onFollow={(e) => {
                e.preventDefault();
                history.push(IMPORT);
              }}
            >
              Import page
            </Link>{' '}
            to download the CloudFormation templates:
          </p>
          <ul>
            <li>
              <strong>Global Resources Template</strong> — Deploy once per
              account
            </li>
            <li>
              <strong>Regional Resources Template</strong> — Deploy to each
              target region
            </li>
          </ul>
        </TextContent>
      </Box>
    </SpaceBetween>
  );
};

export default CfDownloadStep;
